import activityTypes from './activity-types'
import bankingCorrespondents from './banking-correspondents'
import channels from './channels'
import customersFormConfigs from './customers-form-configs'
import contactLinks from './contact-links'
import funnelsManagement from './funnels-management'
import roulettesFields from './roulettes-fields'
import tags from './tags'

export default [
  ...activityTypes,

  ...bankingCorrespondents,

  ...channels,

  ...customersFormConfigs,

  ...contactLinks,

  ...funnelsManagement,

  ...roulettesFields,

  ...tags,

  {
    name: 'SettingsList',
    path: '/settings',
    component: () => import('pages/settings/SettingsList.vue')
  }
]
